var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.41,
    height: 29.43,
    viewBox: "0 0 48.41 29.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cacaca;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,12.23a9.47,9.47,0,0,0-4.1-.5A13.48,13.48,0,0,0,26,0a13.42,13.42,0,0,0-13.3,8.2,10.32,10.32,0,0,0-6.5.6A11.06,11.06,0,0,0,0,19a11.65,11.65,0,0,0,3.2,7.9,8.57,8.57,0,0,0,6,2.5H39.8a8.86,8.86,0,0,0,6.3-2.7,8.37,8.37,0,0,0,2.3-6,9.52,9.52,0,0,0-6.3-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.5,24.33a5.46,5.46,0,0,1-3.8,1.6H9.1a5.18,5.18,0,0,1-3.5-1.4A8.06,8.06,0,0,1,3.3,19a7.48,7.48,0,0,1,4.1-7,5.83,5.83,0,0,1,2.6-.6,7.17,7.17,0,0,1,2.9.6,1.7,1.7,0,0,0,1.4,0,1.67,1.67,0,0,0,.9-1.1,9.86,9.86,0,0,1,10.3-7.4,10,10,0,0,1,8.8,10.4,1.69,1.69,0,0,0,1.6,1.8h.6a6.82,6.82,0,0,1,4,0,5.94,5.94,0,0,1,4,5.4,4.67,4.67,0,0,1-1.3,3.4h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud1.c50f3a505cd45ef32575273db0ca53d6.svg";
export { ForwardRef as ReactComponent };